import { createApiRef } from '@backstage/core-plugin-api';
import { OpsiclePocApi } from './OpsiclePocApiClient';

export const opsiclePocApiRef = createApiRef<OpsiclePocApi>({
  id: 'plugin.opsicle-poc.service',
});
